<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-dropdown right no-caret variant="link" boundary="window"
                          toggle-class="list-view-icon-btn list-view-icon-btn--primary"
                          v-b-tooltip.hover.bottom title="Agregar categoría">
                <template #button-content><AppIcon name="add" label="Agregar categoría" /></template>
                <b-dropdown-item @click="add('server')"><AppIcon name="dns" /> Categoría para servidores</b-dropdown-item>
                <b-dropdown-item @click="add('system')"><AppIcon name="apps" /> Categoría para sistemas</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </section>
      </b-card>

      <b-tabs v-model="activeTab" @input="onTabChange">
        <b-tab>
          <template #title><AppIcon name="dns" class="mr-1" /> Servidores</template>
          <b-row>
            <b-col>
              <b-table class="app-table"
                        ref="tableServer"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        sticky-header="60vh"
                        :hover="true"
                        :small="true"
                        :fixed="false"
                        :items="table.itemsServer"
                        :fields="table.fieldsServer"
                        :current-page="table.currentPageServer"
                        :per-page="table.perPage"
                        :busy="table.isBusyServer"
                        v-if="table.itemsServer.length || table.isBusyServer">

                <template v-slot:cell(id)="data">
                  <b>#{{data.item.id}}</b>
                </template>

                <template v-slot:cell(name)="data">
                  {{data.item.name}}
                </template>

                <template v-slot:cell(related_count)="data">
                  {{getRelatedCount(data.item)}}
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-instances-categories-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="dns" title="No se encontraron categorías de servidores" />
            <div class="app-table-footer" v-if="table.tablePaginateServer">
              <span class="list-view-toolbar__count">{{ table.tablePaginateServer.total }} registros</span>
            </div>
          </b-col>
        </b-row>
        </b-tab>

        <b-tab>
          <template #title><AppIcon name="apps" class="mr-1" /> Sistemas</template>
          <b-row>
            <b-col>
              <b-table class="app-table"
                      ref="tableSystem"
                      responsive
                      :stacked="isMobileViewport ? 'md' : false"
                      sticky-header="60vh"
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="table.itemsSystem"
                      :fields="table.fieldsSystem"
                      :current-page="table.currentPageSystem"
                      :per-page="table.perPage"
                      :busy="table.isBusySystem"
                      v-if="table.itemsSystem.length || table.isBusySystem">

                  <template v-slot:cell(id)="data">
                    <b>#{{data.item.id}}</b>
                  </template>

                  <template v-slot:cell(name)="data">
                    {{data.item.name}}
                  </template>

                  <template v-slot:cell(related_count)="data">
                    {{getRelatedCount(data.item)}}
                  </template>

                  <template v-slot:cell(f_action)="data">
                    <b-dropdown right no-caret size="sm" variant="link" boundary="window"
                                :toggle-class="isMobileViewport ? 'crud-instances-categories-action-toggle-labeled' : 'app-table-action-toggle'"
                                :class="{ 'pull-right': !isMobileViewport }">
                      <template #button-content>
                        <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                        <span v-if="isMobileViewport">Opciones</span>
                      </template>
                      <b-dropdown-item @click="edit(data.item)">
                        <AppIcon name="edit" /> Editar
                      </b-dropdown-item>
                      <b-dropdown-item @click="remove(data.item)">
                        <AppIcon name="delete" class="text-danger" /> Eliminar
                      </b-dropdown-item>
                    </b-dropdown>
                  </template>
              </b-table>
              <EmptyState v-else icon="apps" title="No se encontraron categorías de sistemas" />
              <div class="app-table-footer" v-if="table.tablePaginateSystem">
                <span class="list-view-toolbar__count">{{ table.tablePaginateSystem.total }} registros</span>
              </div>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <div>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="arrow_back" class="mr-1" />
              Volver
            </b-button>
          </div>
          <nav v-if="activeTab === 0 && table.tablePaginateServer">
            <b-pagination class="mb-0" size="sm" pills
                          :total-rows="table.tablePaginateServer.total"
                          :per-page="table.tablePaginateServer.per_page"
                          v-model="table.currentPageServer"
                          @input="filterServer()" />
          </nav>
          <nav v-else-if="activeTab === 1 && table.tablePaginateSystem">
            <b-pagination class="mb-0" size="sm" pills
                          :total-rows="table.tablePaginateSystem.total"
                          :per-page="table.tablePaginateSystem.per_page"
                          v-model="table.currentPageSystem"
                          @input="filterSystem()" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="category" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Storage from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.INSTANCIAS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudInstancesCategories',
          elements: {}
        },
        activeTab: 0,
        table : {
          itemsServer: [],
          itemsSystem: [],
          fieldsServer: [],
          fieldsSystem: [],
          currentPageServer: 1,
          currentPageSystem: 1,
          perPage: 0,
          isBusyServer: false,
          isBusySystem: false,
          tablePaginateServer: null,
          tablePaginateSystem: null,
        },
        isMobileViewport: false,
        mobileMql: null,
        crud: {
          form: {
            id: 0,
            name: '',
            type: 'server',
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.restoreTabStorage()
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.setFields()
      this.filterServer()
      this.filterSystem()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      isMobileViewport() {
        this.setFields()
      },
    },
    methods: {
      setFields() {
        this.table.fieldsServer = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
          {key: 'name', label: 'Nombre', class: 'align-middle'},
          {key: 'related_count', label: 'Servidores', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'f_action', label: this.isMobileViewport ? 'Acciones' : '', class: 'align-middle ' + this.alignClass('text-center')},
        ]
        this.table.fieldsSystem = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
          {key: 'name', label: 'Nombre', class: 'align-middle'},
          {key: 'related_count', label: 'Sistemas', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'f_action', label: this.isMobileViewport ? 'Acciones' : '', class: 'align-middle ' + this.alignClass('text-center')},
        ]
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // tab memory
      onTabChange(tabIndex) {
        Storage.setValue('instances_categories_active_tab', tabIndex)
      },
      restoreTabStorage() {
        var savedTab = Storage.getValue('instances_categories_active_tab')
        if(savedTab !== null && savedTab !== undefined) {
          this.activeTab = parseInt(savedTab)
        }
      },
      getRelatedCount(item) {
        if(!item) {
          return 0
        }

        if(item.type === 'server' && item.servers_count !== undefined && item.servers_count !== null) {
          return item.servers_count
        }

        if(item.type === 'system' && item.systems_count !== undefined && item.systems_count !== null) {
          return item.systems_count
        }

        if(item.servers_count !== undefined && item.servers_count !== null) {
          return item.servers_count
        }

        if(item.systems_count !== undefined && item.systems_count !== null) {
          return item.systems_count
        }

        if(Array.isArray(item.servers)) {
          return item.servers.length
        }

        if(Array.isArray(item.systems)) {
          return item.systems.length
        }

        return 0
      },

      // crud
      filterServer() {
        this.table.isBusyServer = true

        var result = serviceAPI.filtrarCategories({ type: 'server' }, this.table.currentPageServer)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginateServer = data
          this.table.itemsServer = data.data

          if(this.$refs.tableServer) {
            this.$refs.tableServer.$forceUpdate()
          }

          this.table.isBusyServer = false
        })
        .catch(() => {
          this.table.isBusyServer = false
        });
      },
      filterSystem() {
        this.table.isBusySystem = true

        var result = serviceAPI.filtrarCategories({ type: 'system' }, this.table.currentPageSystem)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginateSystem = data
          this.table.itemsSystem = data.data

          if(this.$refs.tableSystem) {
            this.$refs.tableSystem.$forceUpdate()
          }

          this.table.isBusySystem = false
        })
        .catch(() => {
          this.table.isBusySystem = false
        });
      },
      add(type) {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.type = type

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = type === 'server' ? "Nueva Categoría para Servidores" : "Nueva Categoría para Sistemas"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.type = item.type

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Categoría"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.type = item.type

        this.confirmDialog('¿Desea borrar la categoría (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Categoría',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCategories(this.crud.form.id);

            result.then(() => {
              this.modal.form.active = false
              loader.hide()
              this.filterServer()
              this.filterSystem()
              this.$awn.success("Categoría eliminada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();

        var result = this.crud.form.id
          ? serviceAPI.editarCategories(this.crud.form)
          : serviceAPI.agregarCategories(this.crud.form)

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.filterServer()
          this.filterSystem()
          this.$awn.success("Cambios guardado con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
<style scoped>
  .btn.crud-instances-categories-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }

  .btn.crud-instances-categories-action-toggle-labeled:hover,
  .btn.crud-instances-categories-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }

  @media (max-width: 767.98px) {
    .app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
